<template>
    <div class="back-title">
        <div class="back-button" @click="goBack">
            <img src="./images/back.png" alt="返回" class="back-button-icon" />
        </div>
        <div class="title">{{ title }}</div>
    </div>
</template>

<script>
    export default {
        name: 'BackTitle',
        props: {
            title: {
                type: String,
                default: ''
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped>
.back-title {
    display: flex;
    align-items: center;
    gap: 28px;
}
.back-button {
    padding: 8px 28px 12px 34px;
    background: #fff3d3;
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
    box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset; 
}
.back-button-icon {
    display: block;
    width: 30px;
    height: 30px;
}
.title {
    font-size: 36px;
    font-weight: bold;
    color: #fff;
}
</style>
